export default {
  'processes.title': 'Processes',
  'processes.start.title': 'Start Request',
  'processes.tab.groups': 'Groups',
  'processes.tab.favorites': 'Favorites',
  'processes.tab.list': 'Processes',
  'processes.form.processGroup': 'Process Group',
  'processes.form.startMode': 'Start Mode',
  'processes.form.instancesNamePattern': 'Request Name Pattern',
  'processes.form.lastGeneratedNumber': 'Last Generated Number',
  'processes.form.isPublicProcess': 'Public?',
  'processes.form.isNotificationsEnabled': 'Notifications Enabled?',
  'processes.form.notificationsFrequency': 'Notifications Frequency',
  'processes.form.notificationsFrequencyValue': 'Notifications Frequency Value',
  'processes.form.startFrequency': 'Start Frequency',
  'processes.form.startFrequencyValue': 'Start Frequency Value',
  'processes.form.startDate': 'Start Date',
  'processes.form.lastStartDate': 'Last Start Date',
  'processes.form.isDeadlineEnabled': 'Enable Execution Time Limit Control?',
  'processes.form.deadlineMeasureUnit': 'Time Control Unit',
  'processes.form.deadlineMeasureValue': 'Time Control Value',

  'processes.form.isRequestsLimitEnabled': 'Control Allowed Number of Requests?',
  'processes.form.requestsLimit': 'Allowed Number of Requests',
  'processes.form.maxRejectionCount': 'Maximum Rejection Count',
  'processes.form.automaticNumbersCurrentYear': 'Automatic Numbers Current Year',
  'processes.form.automaticNumbersCurrentMonth': 'Automatic Numbers Current Month',
  'processes.form.automaticNumbersCurrentDay': 'Automatic Numbers Current Day',
  'processes.form.disableSendApprovedRequestMailAtEnd': 'Disable Send Approved Request Mail at End',
  'processes.form.disableSendRejectedRequestMailAtEnd': 'Disable Send Rejected Request Mail at End',
  'processes.form.isSendErrorNotificationsEnabled': 'Enable Error Notifications?',
  'processes.form.isBulkRequestCreationEnabled': 'Enable Bulk Request Creation?',
  'processes.form.isAllowViewWithoutAuthenticatingEnabled': 'Allow View Without Authentication?',
  'processes.form.isAllowApprovalWithoutAuthenticatingEnabled':
    'Allow Approval Without Authentication?',
  'processes.form.disableRequestCancellation': 'Disable Request Cancellation',
  'processes.form.commentsAccessMode': 'Comments Access Mode',
  'processes.form.commentsAccessMode.disabled': 'Disabled',
  'processes.form.commentsAccessMode.readOnly': 'Read-only',
  'processes.form.commentsAccessMode.appendOnly': 'Append-only (no edit or delete)',
  'processes.form.commentsAccessMode.delete': 'Delete-only (moderation)',
  'processes.form.commentsAccessMode.edit': 'Edit (no delete)',
  'processes.form.commentsAccessMode.editAndDelete': 'Edit and delete',
  'processes.form.isShowPercentEnabled': 'Show Progress Percentage?',
  'processes.form.percentActionsCount': 'Actions Count for Percentage',
  'processes.form.offlineEnabled': 'Enable Offline Mode',

  // Wizard Steps
  'processes.wizard.steps.basicInformation': 'Basic Information',
  'processes.wizard.steps.namePatterns': 'Name Patterns',
  'processes.wizard.steps.notificationSettings': 'Notification Settings',
  'processes.wizard.steps.startMode': 'Start Mode',
  'processes.wizard.steps.requestsLimitDeadline': 'Requests Limit & Deadline',
  'processes.wizard.steps.others': 'Other Settings',

  'processes.select.instant': 'Manual Flow',
  'processes.select.automated': 'Automated Flow',
  'processes.select.scheduled': 'Scheduled Flow',

  'processes.configure.title': 'Configure Process',
  'process.SearchInput.placeholder': 'Search Configuration',

  'process.text.fileName': 'Name',
  'process.text.userCreator': 'Author',
  'process.text.contentType': 'File Type',
  'process.text.options': 'Options',
  'process.text.processGroups': 'Process Groups',
  'process.text.processPortal': 'Process Portal',
  'process.text.completed': 'Completed',
  'process.text.manually': 'Manual',
  'process.text.automatic': 'Automatic',
  'process.text.schedule': 'Scheduled',

  'process.text.reportName': 'Name',
  'process.text.reportType': 'Type',
  'process.text.listName': 'Name',
  'process.text.listType': 'Type',
  'process.text.portalName': 'Name',
  'process.text.portalCode': 'Code',

  'process.button.bulk.upload': 'Upload Excel Format Requests',
  'process.button.bulk.label': 'Click to upload',

  'process.text.bulk.download': 'Excel template for bulk upload applications',
  'process.text.bulk.upload': 'Excel bulk upload for applications',
  'process.text.bulk.isScheduledProcessingEnabled': 'Enable Scheduled Processing Date?',
  'process.text.bulk.attachments': 'Excel Document',
  'process.text.bulk.scheduledProcessingDate': 'Scheduled Processing Date',
  'process.text.bulk.download.loading': 'Downloading Requests Template file...',
  'process.text.bulk.download.success': 'Successfully downloaded the template file.',

  'process.text.reports.reportType1': 'Administration',
  'process.text.reports.reportType2': 'Process',
  'process.text.reports.reportType3': 'Request',
  'process.text.reports.reportType4': 'Generic',
  'process.text.reports.reportType5': 'PowerBIConnector',

  'process.text.lists.listType1': 'List',
  'process.text.lists.listType2': 'Gant',
  'process.text.lists.listType3': 'Calendar',
  'process.text.lists.listType4': 'Task',
  'process.text.lists.listType6': 'Cards',
  'process.text.lists.listType7': 'Map',
  'process.canvas.note.placeholder': 'Like a note...',
  'process.approval.card.general.description': 'General approval configuration',
  'process.approval.card.rejection.description': 'Rejection settings and rejection control',
  'process.approval.card.deadline.description': 'Execution time limit control',
  'process.approval.card.filters.general.description': 'General approver filters configuration',
  'process.approval.card.filters.users.description': 'Filter approvers by specific users',
  'process.approval.card.filters.positions.description': 'Filter approvers by positions',
  'process.approval.card.filters.areas.description': 'Filter approvers by areas',
  'process.approval.card.filters.userGroups.description': 'Filter approvers by user groups',
  'process.approval.card.filters.externalUsers.description': 'Filter approvers by external users',
  'process.approval.card.filters.agents.description': 'Filter approvers by AI agents',
  'process.approval.card.filters.userExtraFields.description':
    'Filter approvers by user extra fields',
  'process.approval.card.filters.global.description':
    'Configure global approver filters (7 sub-groups)',
  'process.approval.card.filters.formField.description':
    'Filter approvers by form fields (4 sub-groups)',
  'process.approval.filters.externalUsers.alert.title': 'Simplified Configuration',
  'process.approval.filters.externalUsers.alert.description':
    'This is a simplified version that handles a single external user filter. For full management of multiple items, use the list + drawer implementation.',
  'process.approval.filters.userExtraFields.alert.title': 'Simplified Configuration',
  'process.approval.filters.userExtraFields.alert.description':
    'This is a simplified version that handles a single extra user field filter. For full management of multiple items, use the list + drawer implementation.',

  'process.v1ConfigURL.noURL': 'No configuration URL provided',
};
